import { FilterType } from '../../filters/models/filter-type';
import { ColumnType } from './column-type';

/**
 * Représente la définition d'une colonne.
 */
export class ColumnDefinition {
    constructor(
        public columnName: string = null,
        public headerText: string = null,
        public type: ColumnType = ColumnType.Text,
        public filterType = FilterType.None,
        public position: number = -1,
        public size: number = 15,
        public isVisible: boolean = true,
        public tooltip: string = null,
        public sortDisabled = false
    ) {}

    public cell(row: Document): string {
        if (row[this.columnName] == null) {
            return '';
        } else {
            return `${row[this.columnName]}`;
        }
    }
}
